import { PatientsActionTypes } from './type';

/** **** action creator ******/

/** **** 编辑患者基础信息 ******/
export const edit_patient = (data: any) => ({ type: PatientsActionTypes.EDIT_PATIENT, data });

/** **** 编辑患者基础信息 ******/
export const edit_patient_info = (key: string, value: any) => ({ type: PatientsActionTypes.EDIT_PATIENT_INFO, key, value });

/** **** 编辑患者健康 ******/
export const edit_patient_health = (key: string, value: any) => ({ type: PatientsActionTypes.EDIT_PATIENT_HEALTH, key, value });
/** **** 编辑患者血糖血压信息 ******/
export const edit_patient_bloodsugar = (key: string, value: any) => ({ type: PatientsActionTypes.EDIT_PATIENT_BLOODSUGAR, key, value });

/** **** 编辑患者附件信息 ******/
export const edit_patient_attachment = (key: string, value: any) => ({ type: PatientsActionTypes.EDIT_PATIENT_ATTACHMENT, key, value });

/** **** 获取患者列表 ******/
export const fetch_patients_list = (data?: any, onSuccess?: any) => ({ type: PatientsActionTypes.FETCH_PATIENT_LIST, data, onSuccess });

/** **** 获取患者问诊单列表 ******/
export const fetch_patient_inquiry = (patientId: string) => ({ type: PatientsActionTypes.FETCH_PATIENT_INQUIRY, patientId });

/** **** 获取新增患者的业务编号 ******/
export const fetch_patient_no = () => ({ type: PatientsActionTypes.FETCH_PATIENT_NO });

/** **** 获取新增患者的业务编号 ******/
export const fetch_patient_detail = (patientId: string | number,option?: object, onSuccess?: any) => ({ type: PatientsActionTypes.FETCH_PATIENT_DETAIL, patientId,option, onSuccess });

/** **** 保存患者信息/新增患者信息 ******/
export const save_patient = (onSuccess?: any, needToast?: boolean) => ({ type: PatientsActionTypes.SAVE_PATIENT, onSuccess, needToast });

/** **** 清除患者信息 ******/
export const clear_patient = () => ({ type: PatientsActionTypes.CLEAR_PATIENT });

/** **** 清除患者列表 ******/
export const clear_patient_list = () => ({ type: PatientsActionTypes.CLEAR_PATIENT_LIST });

/** **** 清除患者问诊单信息 ******/
export const clear_patient_inquiry = () => ({ type: PatientsActionTypes.CLEAR_PATIENT_INQUIRY });

/** **** 删除患者 ******/
export const delete_patient = (patientId: string | number, onSuccess?: any) => ({ type: PatientsActionTypes.DELETE_PATIENT, patientId, onSuccess });

/** **** 上传附件 ******/
export const upload_file = (formData: any, attachmentType: string) => ({ type: PatientsActionTypes.UPLOAD_FILE, formData, attachmentType });

/** **** 删除附件 ******/
export const delete_file = (id: string | number, patientNo: string | number, attachmentType: string | number) => ({ type: PatientsActionTypes.DELETE_FILE, id, patientNo, attachmentType });

/** **** 添加家人 ******/
export const add_family = (data) => ({ type: PatientsActionTypes.ADD_FAMILY, data });

/** **** 保存我的权益默认tab ******/
export const save_default_patient_relation = (data, onSuccess?: any) => ({ type: PatientsActionTypes.SAVE_DEFAULT_PATIENTRELATION, data, onSuccess });


